
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Bookinnovacrystaforoutstationfrompune() {



    const cardData =
    {
        keyword: 'Book Innova Crysta for Outstation From Pune',
        heading: 'Meghana Cab : Book Innova Crysta for Outstation From Pune',
        headingDescription: 'Meghana Cab offers Book Innova Crysta for Outstation From Pune, providing you with a premium, spacious, and reliable travel experience for your long-distance journeys. Whether you are heading to hill stations, pilgrimage sites, or neighboring cities, our Innova Crysta cabs are ideal for family trips, corporate outings, and group travel. Enjoy generous seating, air conditioning, ample luggage space, and comfortable leather interiors—perfect for long hours on the road. Our professional drivers are experienced, courteous, and well-versed with the best routes and scenic stops. With transparent fixed pricing (hourly or per trip), 24/7 customer support, and door-to-door pickups, we ensure a hassle-free travel experience. Book your Innova Crysta for Outstation From Pune with Meghana Cab and embark on your journey with comfort, style, and complete peace of mind',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Mahabaleshwar",
    "description": "Located about 120 km from Pune, Mahabaleshwar is a popular hill station nestled in the Sahyadri range. Known for its cool climate, strawberry farms, and panoramic viewpoints like Arthur’s Seat and Wilson Point, it offers a refreshing escape from city life. Visitors enjoy boating on Venna Lake, visiting Mapro Garden for fresh strawberry desserts, and exploring ancient temples like the Mahabaleshwar and Panchganga Temples. With misty mornings, scenic trekking trails, and cascading waterfalls like Lingmala, it's a perfect weekend getaway for couples, families, and nature enthusiasts."
  },
  {
    "title": "Lonavala & Khandala",
    "description": "Just 65–70 km from Pune, the twin hill stations of Lonavala and Khandala are beloved for their lush greenery, mist-covered hills, and monsoon magic. Famous spots include Bhushi Dam, Tiger's Leap, Rajmachi Fort, and Karla-Bhaja Caves. These destinations are perfect for scenic drives, treks, picnics, and exploring natural beauty. During the rainy season, dozens of small waterfalls spring to life. With charming resorts, adventure parks, and fresh chikki shops, Lonavala-Khandala makes an ideal day trip or overnight retreat."
  },
  {
    "title": "Shirdi",
    "description": "Located around 190 km from Pune, Shirdi is a major pilgrimage destination known for the holy shrine of Shri Sai Baba. Devotees from across the country visit the Sai Baba Samadhi Mandir, Dwarkamai, Chavadi, and other associated sites to seek blessings. The temple complex is well-organized and offers accommodation, prasadalaya, and spiritual programs. It's an ideal destination for spiritual seekers, and cab services from Pune to Shirdi are often booked for one-day or overnight round trips."
  },
  {
    "title": "Lavasa",
    "description": "About 60 km from Pune, Lavasa is a planned hill city inspired by Italian town Portofino. Nestled among green hills and beside a lake, it's known for its colorful architecture, waterside promenades, and adventure activities like kayaking, boating, and zip-lining. The pleasant weather, scenic drives, and boutique stays make Lavasa a great pick for a quick romantic getaway or a family day out. The tranquil surroundings also attract corporate outings and pre-wedding shoots."
  },
  {
    "title": "Alibaug",
    "description": "Roughly 145 km from Pune via road or ferry (via Mumbai), Alibaug is a charming coastal town famous for its clean beaches, historic sea forts, and seafood cuisine. Popular beaches include Alibaug Beach, Nagaon Beach, and Kashid Beach. Kolaba Fort, located in the sea, is a must-visit. With homestays, beach resorts, and water sports, Alibaug is ideal for weekend trips, beach picnics, and monsoon road journeys from Pune. It’s also a favorite among bikers and backpackers."
  },
  {
    "title": "Nashik",
    "description": "Approximately 210 km from Pune, Nashik is a vibrant city known for its religious, historical, and wine tourism appeal. It hosts the Kumbh Mela and is home to the sacred Godavari River, Panchavati temples, and Trimbakeshwar Jyotirlinga. Nashik also offers a taste of luxury with premium vineyards like Sula, York, and Grover Zampa—where visitors can tour wineries, taste wines, and dine with vineyard views. With spiritual and leisure experiences, Nashik is a diverse outstation option."
  },
  {
    "title": "Goa",
    "description": "At a distance of around 450 km from Pune, Goa is India’s most famous beach destination. Known for its sun-kissed beaches like Baga, Calangute, Anjuna, and Palolem, it also offers Portuguese churches, forts like Aguada, buzzing nightlife, flea markets, and authentic seafood. Whether it’s relaxation, adventure, or culture, Goa caters to every traveler’s taste. Outstation cabs from Pune to Goa are often booked for 3–5 day trips covering both North and South Goa highlights."
  },
  {
    "title": "Kolhapur",
    "description": "Located about 235 km from Pune, Kolhapur is known for the revered Mahalaxmi Temple, spicy cuisine, Kolhapuri chappals, and its royal Maratha heritage. The New Palace, Rankala Lake, Jyotiba Temple, and Panhala Fort are major attractions. Kolhapur is perfect for pilgrims, history lovers, and foodies seeking a culturally rich short trip from Pune. It’s also a gateway to the Western Ghats and heritage trails of Maharashtra."
  },
  {
    "title": "Bhimashankar",
    "description": "Situated 110 km from Pune, Bhimashankar is home to one of the twelve Jyotirlingas of Lord Shiva. Nestled deep in the Sahyadri forest range, it is both a spiritual and ecological hotspot. The dense forest around the temple is a wildlife sanctuary known for the rare Giant Indian Squirrel (Shekru). The combination of a sacred temple, lush trekking trails, and misty mountain air makes Bhimashankar an ideal outstation pilgrimage and nature trek destination."
  },
  {
    "title": "Ajanta & Ellora Caves (Aurangabad)",
    "description": "About 250–270 km from Pune, these UNESCO World Heritage Sites in Aurangabad district are archaeological wonders. The Ajanta Caves, dating back to the 2nd century BCE, feature Buddhist rock-cut cave temples with exquisite murals and sculptures. The Ellora Caves house Hindu, Buddhist, and Jain monuments, including the monumental Kailasa Temple carved from a single rock. These sites are best visited on a two-day trip from Pune, combining history, art, and awe-inspiring craftsmanship."
  }
],

"services": [
  {
    "name": "Book Outstation Innova Crysta Pune",
    "description": "Easily book an outstation Innova Crysta from Pune for a comfortable and safe journey to your favorite destinations. Whether it’s a weekend getaway or a multi-day trip, enjoy spacious seating, professional chauffeurs, and reliable service tailored to your travel needs."
  },
  {
    "name": "Rent Innova Crysta for Outstation Pune",
    "description": "Rent a premium Innova Crysta for outstation travel from Pune and experience a blend of luxury, comfort, and performance. Our well-maintained SUVs ensure smooth rides on highways, perfect for family trips, corporate tours, and sightseeing excursions."
  },
  {
    "name": "Outstation Taxi Innova Crysta Pune",
    "description": "Our outstation taxi service with Innova Crysta from Pune offers reliable and flexible travel options for long-distance journeys. Enjoy privacy, safety, and professional chauffeurs who are familiar with major routes and hill stations."
  },
  {
    "name": "Pune Outstation Innova Crysta Cab Booking",
    "description": "Book your outstation Innova Crysta cab from Pune through our convenient online platform. Get instant confirmations, transparent pricing, and customizable itineraries to ensure your trip is stress-free and enjoyable."
  },
  {
    "name": "AC Innova Crysta Outstation Hire Pune",
    "description": "Travel comfortably on outstation trips from Pune with our fully air-conditioned Innova Crysta hire service. Beat the heat and fatigue with plush interiors and climate control, making every journey refreshing regardless of the distance."
  },
  {
    "name": "Chauffeur Driven Innova Crysta Outstation Pune",
    "description": "Relax and enjoy your outstation travel from Pune with our chauffeur-driven Innova Crysta service. Our experienced drivers prioritize your safety, offer courteous service, and ensure punctuality, so you can focus on enjoying your trip."
  },
  {
    "name": "Family Trip Innova Crysta Outstation Pune",
    "description": "Make your family outstation trips from Pune stress-free and comfortable by hiring our spacious Innova Crysta. With ample legroom and luggage space, this service is ideal for group travel, ensuring a pleasant journey for everyone."
  },
  {
    "name": "Affordable Innova Crysta Outstation Pune",
    "description": "Get the best value on outstation Innova Crysta rentals from Pune with our affordable pricing plans. Enjoy premium features and reliable service without breaking your budget, perfect for travelers who seek comfort at great rates."
  },
  {
    "name": "Online Innova Crysta Outstation Booking Pune",
    "description": "Book your outstation Innova Crysta from Pune online with ease. Our platform offers secure payments, flexible scheduling, and instant confirmation to help you plan your long-distance travel effortlessly."
  }
],
"tableData": [
  ["Book Outstation Innova Crysta Pune", "Rent Innova Crysta for Outstation Pune"],
  ["Outstation Taxi Innova Crysta Pune", "Pune Outstation Innova Crysta Cab Booking"],
  ["AC Innova Crysta Outstation Hire Pune", "Chauffeur Driven Innova Crysta Outstation Pune"],
  ["Family Trip Innova Crysta Outstation Pune", "Affordable Innova Crysta Outstation Pune"],
  ["Online Innova Crysta Outstation Booking Pune", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable Innova Crysta Outstation Booking from Pune",
        "WhyChoosedescription": "Book our Innova Crysta for comfortable and hassle-free outstation travel from Pune. Whether you’re visiting nearby hill stations, tourist destinations, or neighboring cities, enjoy a smooth and luxurious ride tailored to your schedule."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Vehicle for Long Journeys",
        "WhyChoosedescription": "The Innova Crysta offers ample space with premium seating for up to 6-7 passengers, ensuring everyone travels comfortably. Its advanced suspension and air-conditioning make long-distance travel relaxing and enjoyable."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with Outstation Routes",
        "WhyChoosedescription": "Our professional drivers are well-versed with major outstation routes from Pune, ensuring safe and timely journeys. They prioritize your safety while providing courteous and helpful service throughout the trip."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
        "WhyChoosedescription": "Every Innova Crysta is regularly serviced and sanitized before every journey to guarantee your safety and comfort. We maintain high standards of cleanliness and vehicle upkeep for a pleasant travel experience."
    },
    {
        "WhyChooseheading": "Flexible Booking and Customized Itineraries",
        "WhyChoosedescription": "Choose from one-way trips, round trips, or multi-day rentals with flexible scheduling. Customize your pickup points, drop locations, and stopovers according to your travel plans and preferences."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our pricing is clear and all-inclusive, covering fuel, tolls, taxes, and driver allowances. Enjoy premium service with competitive rates and no unexpected costs."
    },
    {
        "WhyChooseheading": "Ideal for Family Trips, Corporate Travel, and Group Outings",
        "WhyChoosedescription": "Whether it’s a family vacation, a business trip, or a group excursion, our Innova Crysta outstation service offers the space, comfort, and reliability you need for a memorable journey."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Easy Online Booking",
        "WhyChoosedescription": "Our customer service team is available round the clock to assist with bookings, changes, or special requests. Book your Innova Crysta outstation cab from Pune anytime, hassle-free."
    }
]


















    }

const faqData = [
    {
        question: "How do I book an Innova Crysta for outstation travel from Pune?",
        answer: "You can easily book by calling Meghana Cab at +91 9075462128 or through our website for instant booking."
    },
    {
        question: "Is Innova Crysta suitable for long outstation trips?",
        answer: "Yes, Innova Crysta is spacious, comfortable, and ideal for long-distance travel with families or groups."
    },
    {
        question: "What is the seating capacity of the Innova Crysta?",
        answer: "The Innova Crysta can seat up to 6 or 7 passengers comfortably with ample luggage space."
    },
    {
        question: "Can I choose between one way and round trip options for outstation travel?",
        answer: "Yes, we offer both one way and round trip options to meet your travel needs."
    },
    {
        question: "Is the Innova Crysta cab service available 24/7 from Pune?",
        answer: "Yes, our outstation Innova Crysta cab service is available round the clock."
    },
    {
        question: "What is included in the Innova Crysta fare for outstation travel?",
        answer: "The fare includes driver charges, fuel, and tolls. Extra charges may apply for parking or waiting time."
    },
    {
        question: "Are the vehicles sanitized and well-maintained?",
        answer: "Absolutely. All Innova Crysta vehicles are regularly serviced and sanitized for passenger safety and comfort."
    },
    {
        question: "Can I book the cab on short notice for an outstation trip?",
        answer: "Yes, short notice bookings are accepted based on availability. Early booking is recommended for best service."
    },
    {
        question: "Do the drivers have experience in long-distance travel?",
        answer: "Yes, our drivers are experienced, courteous, and familiar with major outstation routes from Pune."
    },
    {
        question: "What are the payment options available?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Nilesh Wagh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked an Innova Crysta for our outstation trip to Goa from Pune. Extremely comfortable ride and excellent driver.”',
    },
    {
        name: 'Ms. Vaishali Phadke',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Great service by Meghana Cab. Clean Innova Crysta and smooth outstation journey with my family.”',
    },
];








































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Outstation Innova Crysta Cab Booking from Pune",
  "description": "Book Innova Crysta for outstation trips from Pune. Comfortable AC taxi with chauffeur for family and business travel. Affordable and easy online booking available.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "serviceType": "Outstation Innova Crysta Taxi Hire",
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/outstation-innova-crysta-pune"
  }
};







    return (
        <div>
<Helmet>
  <title>Book Innova Crysta for Outstation from Pune | Meghana Cabs</title>
  <meta
    name="description"
    content="Book Innova Crysta for outstation trips from Pune with AC, chauffeur-driven taxi. Affordable, comfortable rides for family and business. Online booking available."
  />
  <meta
    name="keywords"
    content="Book Outstation Innova Crysta Pune, Rent Innova Crysta for Outstation Pune, Outstation Taxi Innova Crysta Pune, Pune Outstation Innova Crysta Cab Booking, AC Innova Crysta Outstation Hire Pune, Chauffeur Driven Innova Crysta Outstation Pune, Family Trip Innova Crysta Outstation Pune, Affordable Innova Crysta Outstation Pune, Online Innova Crysta Outstation Booking Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(serviceSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/51.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bookinnovacrystaforoutstationfrompune;